<template>
	<v-row class="mx-n6 mb-0">
		<v-col cols="12">
			<v-card elevation="0">
				<v-expansion-panels>
					<v-expansion-panel>
						<v-expansion-panel-header>
							<div class="d-flex flex-column">
								<span class="d-flex align-center font-weight-medium text-truncate name">
									{{ user.username }}
									<v-icon
										x-small
										class="ml-1 copy-icon"
										@click.stop="copyToClipboard(user.username)"
									>mdi-content-copy</v-icon>
									<v-icon
										x-small
										class="ml-1"
										:color="user.privateRecording ? 'error' : 'success'"
									>{{ user.privateRecording ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
								</span>
								<span class="d-block text-truncate text-caption text--secondary">
									{{ user.displayName }}
								</span>
								<span v-if="!user.password?.length" class="d-block text-truncate text-caption red--text font-weight-bold">
									{{ $t("sip-password-missing") }}
								</span>
							</div>

							<v-spacer class="mt-n4" />

							<v-icon
								color="primary"
								class="mr-2 edit-icon"
								@click.stop="$emit('onEdit', user)"
							>
								mdi-pencil
							</v-icon>

							<v-checkbox
								v-model="checkboxValue"
								hide-details
								class="mr-2 mt-n1"
								@click.stop
								@change="handleCheckboxChange"
							/>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-divider />
							<span class="d-block mt-2 font-weight-regular name">
								<strong>{{ $t("display-name") }}:</strong>
								{{ user.displayName }}
							</span>

							<span class="d-flex align-center mt-2 font-weight-regular name">
								<strong>{{ $t("password") }}:</strong>
								{{ user.password }}
								<v-icon
									v-if="user.password?.length"
									x-small
									class="ml-1 copy-icon"
									@click="copyToClipboard(user.password)"
								>mdi-content-copy</v-icon>
							</span>

							<span class="d-block mt-2 font-weight-regular name">
								<strong>{{ $t("sip-private-recording") }}:</strong>
								<v-icon small class="ml-1" :color="user.privateRecording ? 'success' : 'grey'">{{ user.privateRecording ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
							</span>

							<span class="d-block mt-2 font-weight-regular name">
								<strong>{{ $t("sip-default-group") }}:</strong>
								{{ user.defaultUserGroupName || $t("none") }}
							</span>

							<span class="d-block mt-2 font-weight-regular name">
								<strong>{{ $t("user-associated") }}:</strong>
								{{ fullName(user.name || "") }}
							</span>

							<v-row class="d-flex justify-start pl-n6 pt-2">
								<v-col cols="2" class="d-flex">
									<strong>{{ $t("groups") }}:</strong>
								</v-col>

								<v-col cols="10" class="d-flex flex-wrap justify-start">
									<v-btn
										v-for="group in user.groups"
										:key="group?.id"
										color="primary"
										class="rounded-xl mr-2 mb-2 group"
										small
									>
										{{ group?.label }}
									</v-btn>
								</v-col>
							</v-row>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import { fullName } from "@/common/utils";

export default {
	name: "SipUser",

	props: {
		user: {
			type: Object,
			default: undefined
		},

		selected: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			checkboxValue: this.selected
		};
	},

	watch: {
		selected(newValue) {
			this.checkboxValue = newValue;
		}
	},

	methods: {
		fullName,

		async copyToClipboard(text) {
			try {
				await navigator.clipboard.writeText(text);
				this.$success(this.$t("copied-to-clipboard"));
			} catch {
				this.$error(this.$t("error.copy-to-clipboard"));
			}
		},

		handleCheckboxChange(value) {
			this.$emit("checkboxChanged", { sipSid: this.user.sipSid, value: this.checkboxValue });
		}
	}
};
</script>
<style scoped>
.user-info {
	min-height: 40px;
	width: 100%;
}
.name {
	width: calc(100%);
}

.group {
	pointer-events: none;
}

.edit-icon {
	flex: 0 0 auto;
}

.copy-icon {
	cursor: pointer;
	opacity: 0.6;
}

.copy-icon:hover {
	opacity: 1;
}
</style>
